// extracted by mini-css-extract-plugin
export default {"HobbyOrganism":"HobbysStyles_HobbyOrganism__Yob+n","Hidden":"HobbysStyles_Hidden__MF9st","Visible":"HobbysStyles_Visible__N8vNZ"};